import FoodItem from "@/model/food-database/FoodItem";

export default class DailyMenuOptionOffer {
  private constructor (
    readonly id: string,
    readonly foodItem: FoodItem,
    readonly portionsCount: string | undefined

  ) {}


  static createFromResponse (responseData: any): DailyMenuOptionOffer | undefined {

    if( !responseData )
      return undefined

    return new DailyMenuOptionOffer(
      responseData.id,
      responseData.foodItem,
        responseData.portionsCount
    )

  }
}
